<style lang="stylus">
    .focus-tool-positioncontainer
        width 270px
        padding 10px
        background var(--bg--color-tertiary)
        border-bottom-left-radius 5px
        border-bottom-right-radius 5px
        display flex
        flex-wrap wrap
        justify-content space-between
        .fix-ratio
            position relative
            margin-top 2px
            width 24px !important
            height 24px
            border-radius 4px
            svg
                position absolute
                top 50%
                left 50%
                width 18px
                height 8px
                transform translate(-50%,-50%)
                color var(--svg-color-gray-42)
            &:hover
                background-color $common-hover-color
                cursor pointer
        .actived-btn
            background-color $common-select-color !important
        .block-input
            width 110px
            .ivu-input-number-handler-wrap, .ivu-input-number-input
                background-color var(--bg-color-tertiary)

            >svg
                width 18px
                height 8px
            p
                width 18px
                text-align right
                display inline-block
                font-size 12px
                margin 5px 0
                margin-right 4px
</style>

<template>
    <DragBox
        :dragTitle="dragTitle"
        :originPostion="{ left: `${originPostion.left}px`, top: `${originPostion.top}px` }"
        :style="{ left: `${originPostion.left}px`, top: `${originPostion.top}px` }"
        :showModal="showModal"
        :lockBox="lockBox"
        @changeLock="changeLock($event)"
        @updateBoxPos="updateBoxPos($event)"
        @removeCloseEvent="removeCloseListener()"
        @closeBox="closeEvent()"
    >
        <div class="focus-tool-positioncontainer">
            <div class="block-input">
                <p>W:</p>
                <InputNumber
                    class="blockinput"
                    v-model="shapeWidth"
                    size="small"
                    :disabled="!isSelect"
                    :min="0"
                    :max="20000"
                    :step="['km', 'mi'].includes(pageUnit) ? 0.0001 : 1"
                    :precision="['km', 'mi'].includes(pageUnit) ? 4 : 1"
                    :formatter="(value) => `${value}${pageUnit}`"
                    :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                    :active-change="false"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            setWidth();
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            setWidth();
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                ></InputNumber>
            </div>
            <div
                class="fix-ratio"
                style="margin-bottom: 17px"
                :class="{ 'actived-btn': fixRatio }"
                :diyStyle="'z-index:1'"
                :content="$t('tipsList.fixRatio')"
                v-tippy="{ placement: 'bottom' }"
                @click="toggleFixRatio"
            >
                <iconSymbol :name="'fixRatio'"></iconSymbol>
            </div>

            <div class="block-input">
                <p>H:</p>
                <InputNumber
                    class="blockinput"
                    v-model="shapeHeight"
                    size="small"
                    :disabled="!isSelect"
                    :min="0"
                    :max="20000"
                    :step="['km', 'mi'].includes(pageUnit) ? 0.0001 : 1"
                    :precision="['km', 'mi'].includes(pageUnit) ? 4 : 1"
                    :formatter="(value) => `${value}${pageUnit}`"
                    :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                    :active-change="false"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            setHeight();
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            setHeight();
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                ></InputNumber>
            </div>
            <div class="block-input">
                <p>X:</p>
                <InputNumber
                    class="blockinput"
                    v-model="shapeX"
                    :disabled="!isSelect"
                    size="small"
                    :min="0"
                    :max="20000"
                    :step="['km', 'mi'].includes(pageUnit) ? 0.0001 : 1"
                    :precision="['km', 'mi'].includes(pageUnit) ? 4 : 1"
                    :formatter="(value) => `${value}${pageUnit}`"
                    :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                    :active-change="false"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            setXPosition();
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            setXPosition();
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                ></InputNumber>
            </div>
            <div class="block-input">
                <p>Y:</p>
                <InputNumber
                    class="blockinput"
                    v-model="shapeY"
                    :disabled="!isSelect"
                    size="small"
                    :min="0"
                    :max="20000"
                    :step="['km', 'mi'].includes(pageUnit) ? 0.0001 : 1"
                    :precision="['km', 'mi'].includes(pageUnit) ? 4 : 1"
                    :formatter="(value) => `${value}${pageUnit}`"
                    :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                    :active-change="false"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            setYPosition();
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            setYPosition();
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                ></InputNumber>
            </div>
        </div>
    </DragBox>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import DragBox from "../Tabs/NavigationDragBox.vue";
    declare var UnitUtil: any;

    @Component({
        components: {
            DragBox,
        },
    })
    export default class FocusExpandToolPosition extends Vue {
        @Inject()
        ["iviewInputBlur"];
        @Prop()
        index;
        @Prop()
        dragTitle;
        @Prop()
        showModal;
        @Prop()
        originPostion;
        @Prop()
        lockBox;

        get pageUnit() {
            let pageUnitList = ["mm", "cm", "m", "km", "in", "ft and in", "ft", "yd", "mi", "pt", "Pica", "Didot", "Cicero", "px"];
            return pageUnitList[this.$store.state.page.pageUnit];
        }
        get fixRatio() {
            return this.$store.state.shape.WHRatio;
        }
        set fixRatio(v) {
            let view = window["_view"];
            this.$store.commit("setShapeStatus", {
                type: "WHRatio",
                data: v,
            });
            view.protectChanged(2);
            view.setActiveShapeFmt();
        }
        get shapeWidth() {
            return this.$store.state.shape.width;
        }
        get shapeHeight() {
            return this.$store.state.shape.height;
        }
        get shapeX() {
            // 暂时使用宽高的值
            return this.$store.state.shape.xPos;
        }
        get shapeY() {
            return this.$store.state.shape.yPos;
        }
        set shapeX(v) {
            this.$store.commit("setShapeStatus", {
                type: "xPos",
                data: v,
            });
        }
        set shapeY(v) {
            this.$store.commit("setShapeStatus", {
                type: "yPos",
                data: v,
            });
        }
        get pUnit() {
            return this.$store.state.page.pageUnit;
        }
        set shapeWidth(v) {
            this.$store.commit("setShapeStatus", {
                type: "width",
                data: v,
            });
            if (this.fixRatio) {
                this.$store.commit("setShapeStatus", {
                    type: "height",
                    data: UnitUtil.pixelToUnit(window["_view"]._activeShape.height, this.pUnit + 9),
                });
            }
        }
        set shapeHeight(v) {
            this.$store.commit("setShapeStatus", {
                type: "height",
                data: v,
            });
            if (this.fixRatio) {
                this.$store.commit("setShapeStatus", {
                    type: "width",
                    data: UnitUtil.pixelToUnit(window["_view"]._activeShape.width, this.pUnit + 9),
                });
            }
        }
        get isSelect() {
            return this.$store.state.shape.isActived;
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        updateBoxPos(pos) {
            this.$emit("updateBoxPos", pos);
        }
        setWidth() {
            window["_view"].setShapeSize(this.shapeWidth, "w");
            window["_view"].getActiveData();
        }
        setHeight() {
            window["_view"].setShapeSize(this.shapeHeight, "h");
            window["_view"].getActiveData();
        }
        setXPosition() {
            window["_view"].setShapePos(this.shapeX, this.shapeY);
            window["_view"].getActiveData();
        }
        setYPosition() {
            window["_view"].setShapePos(this.shapeX, this.shapeY);
            window["_view"].getActiveData();
        }
        toggleFixRatio() {
            this.fixRatio = !this.fixRatio;
        }

        changeLock(e) {
            e && this.$emit("changeLock", this.index);
        }
        removeCloseListener() {
            this.$emit("removeCloseEvent", this.index);
        }
        closeEvent() {
            this.$emit("closeBox", this.index);
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "tipsList": {
      "fixRatio": "锁定纵横比"
    }
  },
  "en": {
    "tipsList": {
      "fixRatio": "Lock aspect ratio"
    }
  },
  "fr": {
    "tipsList": {
      "fixRatio": "Verrouiller le rapport hauteur / largeur"
    }
  },
  "de": {
    "tipsList": {
      "fixRatio": "Seitenverhältnis sperren"
    }
  },
  "jp": {
    "tipsList": {
      "fixRatio": "アスペクト比のロック"
    }
  },
  "es": {
    "tipsList": {
      "fixRatio": "Bloquee la relación de aspecto"
    }
  },
  "pt": {
    "tipsList": {
      "fixRatio": "Bloquear relação de aspecto"
    }
  },
  "it": {
    "tipsList": {
      "fixRatio": "Blocca Rapporto di Aspetto"
    }
  },
  "tw": {
    "tipsList": {
      "fixRatio": "鎖定縱橫比"
    }
  },
  "kr": {
    "tipsList": {
      "fixRatio": "종횡비 고정하기"
    }
  }
}
</i18n>
